exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card {\n  background-color: white;\n  border: 2px solid #15e1d5;\n  border-radius: 5px;\n  width: 100%;\n  padding: 20px;\n  box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.1);\n  position: relative;\n  box-sizing: border-box;\n  margin-bottom: 20px; }\n  @media screen and (min-width: 768px) {\n    .card {\n      min-width: 300px; } }\n  .card__title {\n    font-size: 20px;\n    text-transform: uppercase;\n    text-align: center;\n    margin-bottom: 20px; }\n  .card__remove {\n    position: absolute;\n    right: 0;\n    top: 0;\n    padding: inherit;\n    color: rgba(0, 0, 0, 0.5); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/Card/card.scss
// module id = 5363
// module chunks = 0